<video class="video-step" src="{{stepinfo.result}}" controls>
  {{'report_multimedia_not_available' | translate}}
  <code>{{stepinfo.filename}}</code>.
</video>
<p class="video-title">{{stepinfo.fileName}}</p>
